import useAuthState from '@/states/auth.state';
import useTenantState from '@/states/tenant.state';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Avatar from '@/components/ui/Avatar';
import useOrganizationListState from '@/states/organization-list.state';

export default function Workspaces() {
  const { tenants, loadTenants } = useAuthState();
  const [token, setToken] = useState<string | null>(null);
  console.log('tenants', tenants);
  const { setHomepageCreateNewWorkspace, homepageCreateNewWorkspace } = useTenantState();
  console.log('homepageCreateNewWorkspace', homepageCreateNewWorkspace);
  const navigate = useNavigate();
  const { setCurrentTenant } = useTenantState();
  const { fetchOrganizations } = useOrganizationListState();

  useEffect(() => {
    const fetchToken = async () => {
      const t = await useAuthState.getState().getToken();
      setToken(t);
    };
    fetchToken();
  }, []);

  useEffect(() => {
    if (token && !tenants) {
      loadTenants(token);
    }
  }, [token, tenants]);

  return (
    <section className="h-full relative">
      <div className="flex justify-between items-center px-6 py-4">
        <div className="flex items-center space-x-2">
          <img src={getWorkspaceImage()} alt="alurkerja-logo" className="w-20" />
        </div>

        <button onClick={() => navigate('/my-invitation')} className=" text-primary hover:underline transition-colors">
          Invitations
        </button>
      </div>
      {!homepageCreateNewWorkspace ? (
        <div className="flex flex-col items-center mt-10 gap-y-2 relative z-20 bg-white">
          <h1 className="text-3xl font-medium">Workspaces</h1>
          <p>Choose workspace you've joined</p>

          <div className="mt-6 w-full p-2 md:p-0 md:min-w-[500px] sm:w-[500px] md:w-[786px] ">
            <div className="text-slate-500 text-sm mb-4">My workspaces ({tenants?.length})</div>
            <div className="flex flex-col gap-y-2 overflow-y-auto max-h-[calc(100vh-18rem)] md:max-h-60 rounded-xl">
              {tenants?.map(tenant => {
                return (
                  <button
                    type="button"
                    key={tenant.id}
                    onClick={async () => {
                      setCurrentTenant(tenant);

                      await fetchOrganizations(tenant.id);

                      const orgs = useOrganizationListState.getState().organizations;

                      if (orgs.length > 0) {
                        navigate(`/${tenant.slug}/${orgs[0].id}`, { replace: true });
                      } else {
                        navigate(`/${tenant.slug}`);
                      }
                    }}
                    className="gap-2 p-3 rounded-lg bg-[#F0F5FF] flex items-center cursor-pointer hover:bg-[#e0ebff] transition-colors w-full text-left border-none"
                  >
                    <Avatar name={tenant.name} imagePath={tenant.logoPath} size="md" />
                    <span className="flex-1">{tenant.name}</span>
                  </button>
                );
              })}
            </div>
            {!tenants ||
              (tenants.length === 0 && (
                <button
                  onClick={() => {
                    setHomepageCreateNewWorkspace(true);
                  }}
                  className="p-3 rounded-lg bg-blue-600 text-white flex items-center justify-center cursor-pointer hover:bg-blue-700 transition-colors"
                >
                  Create New Workspace
                </button>
              ))}{' '}
          </div>
        </div>
      ) : (
        <CreateNewWorkspace />
      )}
    </section>
  );
}

const CreateNewWorkspace = () => {
  const [workspaceName, setWorkspaceName] = useState('');
  const { createNewWorkspace } = useTenantState();
  return (
    <div className="flex flex-col items-center mt-10 gap-y-2 relative z-20 bg-white">
      <h1 className="text-[40px] font-medium">Create New Workspace</h1>
      <p className="text-lg">Choose workspace you've joined</p>

      <div className="mt-6 w-full p-2 md:p-0 md:min-w-[500px] sm:w-[500px] md:w-[786px] ">
        <div className="flex flex-col gap-y-2 overflow-y-auto max-h-[calc(100vh-18rem)] md:max-h-60 rounded-xl">
          <input
            type="text"
            placeholder="Workspace name"
            className="p-3 border border-slate-300 rounded-lg"
            value={workspaceName}
            onChange={e => setWorkspaceName(e.target.value)}
          />
          <button
            onClick={() => {
              createNewWorkspace(workspaceName);
            }}
            className="p-3 rounded-lg bg-blue-600 text-white flex items-center justify-center cursor-pointer hover:bg-blue-700 transition-colors"
          >
            Create Workspace
          </button>
        </div>
      </div>
    </div>
  );
};


const getWorkspaceImage = () => {
  const origin = window.location.hostname;
  if (origin.includes('rsm.id')) {
    return '/logo-rsm.jpg';
  }
  return '/AlurKerja.png';
}